import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";

export default function TopBar() {
  return (
    <div className="bg-br-black text-white text-xs border-b border-br-line">
      <div className="container-br flex items-center justify-between py-2">
        <div className="hidden sm:flex items-center gap-5 text-gray-300">
          <a href={`tel:${SITE.phoneE164}`} className="flex items-center gap-2 hover:text-br-bronze-2 transition">
            <Phone size={13} />
            <span className="tracking-wider">{SITE.phone}</span>
          </a>
          <a href={`mailto:${SITE.email}`} className="hidden md:flex items-center gap-2 hover:text-br-bronze-2 transition">
            <Mail size={13} />
            <span>{SITE.email}</span>
          </a>
        </div>
        <div className="flex items-center gap-4 text-gray-300">
          <span className="hidden sm:inline tracking-widest text-[11px] uppercase">Serving Austin & Central Texas</span>
          <Link to="/subcontractor-partnerships" className="hidden sm:inline text-br-bronze-2 hover:text-white font-semibold tracking-wider uppercase">Partner With Us</Link>
          <Link to="/contact" className="text-white sm:hidden font-semibold tracking-wider uppercase">Contact</Link>
          <a href={`tel:${SITE.phoneE164}`} className="sm:hidden flex items-center gap-2 text-br-bronze-2">
            <Phone size={13} /> {SITE.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
